import { Spine } from '@leprecoins/react-pixi';
import { Container } from '@pixi/react';
import { useUnit } from 'effector-react';
import { interactiveElementModel } from '../../model';

export const InteractiveElementGates = () => {
	const [spine] = useUnit([interactiveElementModel.gatesSpine.$spine]);

	return (
		<Container>
			<Spine spine={spine} />
		</Container>
	);
};
